import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';


import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { Integrante } from '../integrante/integrante.model';


// LOAD
export const entityIntegranteLoadRequest = createAction(
  '[ENTITYINTEGRANTE] Load Request'
);

export const entityIntegranteLoadFailure = createAction(
  '[ENTITYINTEGRANTE] Load Failure',
  props<{ error: Error }>()
);

export const entityIntegranteLoadSuccess = createAction(
  '[ENTITYINTEGRANTE] Load Success',
  props<{ items: Integrante[] }>()
);

// ADD
export const entityIntegranteAddRequest = createAction(
  '[ENTITYINTEGRANTE] Add Request',
  props<{ item: Integrante }>()
);

export const entityIntegranteAddFailure = createAction(
  '[ENTITYINTEGRANTE] Add Failure',
  props<{ error: Error }>()
);

export const entityIntegranteAddSuccess = createAction(
  '[ENTITYINTEGRANTE] Add Success',
  props<{ item: Integrante }>()
);

// CHANGE
export const entityIntegranteChangeRequest = createAction(
  '[ENTITYINTEGRANTE] Change Request',
  props<{ item: Integrante }>()
);

export const entityIntegranteChangeFailure = createAction(
  '[ENTITYINTEGRANTE] Change Failure',
  props<{ error: Error }>()
);

export const entityIntegranteChangeSuccess = createAction(
  '[ENTITYINTEGRANTE] Change Success',
  props<{ item: Update<Integrante> }>()
);

// DELETE
export const entityIntegranteDeleteRequest = createAction(
  '[ENTITYINTEGRANTE] Delete Request',
  props<{ item: Integrante }>()
);

export const entityIntegranteDeleteFailure = createAction(
  '[ENTITYINTEGRANTE] Delete Failure',
  props<{ error: Error }>()
);

export const entityIntegranteDeleteSuccess = createAction(
  '[ENTITYINTEGRANTE] Delete Success',
  props<{ item: Integrante }>()
);
